import { t } from 'i18next';

import { ErrorResponseErrorItemCodeAccountUserRequest } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeAccountUserRequest, string> => ({
  'account_user_request:already_verified': t('accountUserRequest.alreadyVerified', {
    ns: 'apiErrorCodes',
    defaultValue: 'Kontot har redan verifierats.',
  }),
  'account_user_request:not_found': t('accountUserRequest.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Ogiltig länk.',
  }),
});
